import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

import type { AllowList } from 'src/features/parkingManagement/types/allowList';

const RESOURCE = '/parkings/:parkingId/allow-list/:listId/';

interface DTO {
    parkingId: string;
    listId: string;
}

type QueryFnType = typeof queryFn;
const queryFn = ({ parkingId, listId }: DTO): Promise<AllowList> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId, listId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetAllowList };
